// Fetch Capacity Table Reports with Pagination
export const FETCH_CAPACITY_TABLE_REPORTS_REQUEST = 'FETCH_CAPACITY_TABLE_REPORTS_REQUEST';
export const FETCH_CAPACITY_TABLE_REPORTS_SUCCESS = 'FETCH_CAPACITY_TABLE_REPORTS_SUCCESS';
export const FETCH_CAPACITY_TABLE_REPORTS_FAILURE = 'FETCH_CAPACITY_TABLE_REPORTS_FAILURE';


// Fetch Notes Edit Actions
export const FETCH_CAPACITY_NOTES_EDIT_REQUEST = 'FETCH_CAPACITY_NOTES_EDIT_REQUEST';
export const FETCH_CAPACITY_NOTES_EDIT_SUCCESS = 'FETCH_CAPACITY_NOTES_EDIT_SUCCESS';
export const FETCH_CAPACITY_NOTES_EDIT_FAILURE = 'FETCH_CAPACITY_NOTES_EDIT_FAILURE';

// Fetch Notes Save Actions
export const FETCH_CAPACITY_NOTES_SAVE_REQUEST = 'FETCH_CAPACITY_NOTES_SAVE_REQUEST';
export const FETCH_CAPACITY_NOTES_SAVE_SUCCESS = 'FETCH_CAPACITY_NOTES_SAVE_SUCCESS';
export const FETCH_CAPACITY_NOTES_SAVE_FAILURE = 'FETCH_CAPACITY_NOTES_SAVE_FAILURE';

// Delete Capacity Report
export const DELETE_CAPACITY_REPORT_REQUEST = 'DELETE_CAPACITY_REPORT_REQUEST';
export const DELETE_CAPACITY_REPORT_SUCCESS = 'DELETE_CAPACITY_REPORT_SUCCESS';
export const DELETE_CAPACITY_REPORT_FAILURE = 'DELETE_CAPACITY_REPORT_FAILURE';

// Get All Capacity Table Published Report List
export const GET_ALL_CAPACITY_TABLE_PUBLISHED_REPORT_LIST_REQUEST = 'GET_ALL_CAPACITY_TABLE_PUBLISHED_REPORT_LIST_REQUEST';
export const GET_ALL_CAPACITY_TABLE_PUBLISHED_REPORT_LIST_SUCCESS = 'GET_ALL_CAPACITY_TABLE_PUBLISHED_REPORT_LIST_SUCCESS';
export const GET_ALL_CAPACITY_TABLE_PUBLISHED_REPORT_LIST_FAILURE = 'GET_ALL_CAPACITY_TABLE_PUBLISHED_REPORT_LIST_FAILURE';

// Enable/Disable Capacity Table Report
export const ENABLE_DISABLE_CAPACITY_TABLE_REPORT_REQUEST = 'ENABLE_DISABLE_CAPACITY_TABLE_REPORT_REQUEST';
export const ENABLE_DISABLE_CAPACITY_TABLE_REPORT_SUCCESS = 'ENABLE_DISABLE_CAPACITY_TABLE_REPORT_SUCCESS';
export const ENABLE_DISABLE_CAPACITY_TABLE_REPORT_FAILURE = 'ENABLE_DISABLE_CAPACITY_TABLE_REPORT_FAILURE';

// CoverageGapTool Data Refresh
export const COVERAGE_GAP_TOOL_DATA_REFRESH_REQUEST = 'COVERAGE_GAP_TOOL_DATA_REFRESH_REQUEST';
export const COVERAGE_GAP_TOOL_DATA_REFRESH_SUCCESS = 'COVERAGE_GAP_TOOL_DATA_REFRESH_SUCCESS';
export const COVERAGE_GAP_TOOL_DATA_REFRESH_FAILURE = 'COVERAGE_GAP_TOOL_DATA_REFRESH_FAILURE';

// Get Rad Shift Paste Input All Dropdown List
export const GET_RAD_SHIFT_PASTE_INPUT_ALL_DD_LIST_REQUEST = 'GET_RAD_SHIFT_PASTE_INPUT_ALL_DD_LIST_REQUEST';
export const GET_RAD_SHIFT_PASTE_INPUT_ALL_DD_LIST_SUCCESS = 'GET_RAD_SHIFT_PASTE_INPUT_ALL_DD_LIST_SUCCESS';
export const GET_RAD_SHIFT_PASTE_INPUT_ALL_DD_LIST_FAILURE = 'GET_RAD_SHIFT_PASTE_INPUT_ALL_DD_LIST_FAILURE';

// Get Shift Paste Input Filter Data With Pagination
export const GET_SHIFT_PASTE_INPUT_FILTER_DATA_WITH_PAGINATION_REQUEST = 'GET_SHIFT_PASTE_INPUT_FILTER_DATA_WITH_PAGINATION_REQUEST';
export const GET_SHIFT_PASTE_INPUT_FILTER_DATA_WITH_PAGINATION_SUCCESS = 'GET_SHIFT_PASTE_INPUT_FILTER_DATA_WITH_PAGINATION_SUCCESS';
export const GET_SHIFT_PASTE_INPUT_FILTER_DATA_WITH_PAGINATION_FAILURE = 'GET_SHIFT_PASTE_INPUT_FILTER_DATA_WITH_PAGINATION_FAILURE';

// Get Shift Paste Input Refresh Data With Pagination Action Types
export const GET_SHIFT_PASTE_INPUT_REFRESH_DATA_WITH_PAGINATION_REQUEST = 'GET_SHIFT_PASTE_INPUT_REFRESH_DATA_WITH_PAGINATION_REQUEST';
export const GET_SHIFT_PASTE_INPUT_REFRESH_DATA_WITH_PAGINATION_SUCCESS = 'GET_SHIFT_PASTE_INPUT_REFRESH_DATA_WITH_PAGINATION_SUCCESS';
export const GET_SHIFT_PASTE_INPUT_REFRESH_DATA_WITH_PAGINATION_FAILURE = 'GET_SHIFT_PASTE_INPUT_REFRESH_DATA_WITH_PAGINATION_FAILURE';

// Publish Capacity Table Report Action Types
export const PUBLISH_CAPACITY_TABLE_REPORT_REQUEST = 'PUBLISH_CAPACITY_TABLE_REPORT_REQUEST';
export const PUBLISH_CAPACITY_TABLE_REPORT_SUCCESS = 'PUBLISH_CAPACITY_TABLE_REPORT_SUCCESS';
export const PUBLISH_CAPACITY_TABLE_REPORT_FAILURE = 'PUBLISH_CAPACITY_TABLE_REPORT_FAILURE';

// Get Capacity Table Report
export const GET_CAPACITY_TABLE_REPORT_REQUEST = 'GET_CAPACITY_TABLE_REPORT_REQUEST';
export const GET_CAPACITY_TABLE_REPORT_SUCCESS = 'GET_CAPACITY_TABLE_REPORT_SUCCESS';
export const GET_CAPACITY_TABLE_REPORT_FAILURE = 'GET_CAPACITY_TABLE_REPORT_FAILURE';

// Get Active Radiologist Data By ID
export const GET_ACTIVE_RAD_DATA_BY_ID_REQUEST = 'GET_ACTIVE_RAD_DATA_BY_ID_REQUEST';
export const GET_ACTIVE_RAD_DATA_BY_ID_SUCCESS = 'GET_ACTIVE_RAD_DATA_BY_ID_SUCCESS';
export const GET_ACTIVE_RAD_DATA_BY_ID_FAILURE = 'GET_ACTIVE_RAD_DATA_BY_ID_FAILURE';

// Get Pending Radiologist Data By ID
export const GET_PENDING_RAD_DATA_BY_ID_REQUEST = 'GET_PENDING_RAD_DATA_BY_ID_REQUEST';
export const GET_PENDING_RAD_DATA_BY_ID_SUCCESS = 'GET_PENDING_RAD_DATA_BY_ID_SUCCESS';
export const GET_PENDING_RAD_DATA_BY_ID_FAILURE = 'GET_PENDING_RAD_DATA_BY_ID_FAILURE';

// Get Offboarding Radiologist Data By ID
export const GET_OFFBOARDING_RAD_DATA_BY_ID_REQUEST = 'GET_OFFBOARDING_RAD_DATA_BY_ID_REQUEST';
export const GET_OFFBOARDING_RAD_DATA_BY_ID_SUCCESS = 'GET_OFFBOARDING_RAD_DATA_BY_ID_SUCCESS';
export const GET_OFFBOARDING_RAD_DATA_BY_ID_FAILURE = 'GET_OFFBOARDING_RAD_DATA_BY_ID_FAILURE';

export const SAVE_IS_EXCLUDED_REQUEST = 'SAVE_IS_EXCLUDED_REQUEST';
export const SAVE_IS_EXCLUDED_SUCCESS = 'SAVE_IS_EXCLUDED_SUCCESS';
export const SAVE_IS_EXCLUDED_FAILURE = 'SAVE_IS_EXCLUDED_FAILURE';

// Get Duplicate Schedule Data
export const GET_DUPLICATE_SCHEDULE_DATA_REQUEST = 'GET_DUPLICATE_SCHEDULE_DATA_REQUEST';
export const GET_DUPLICATE_SCHEDULE_DATA_SUCCESS = 'GET_DUPLICATE_SCHEDULE_DATA_SUCCESS';
export const GET_DUPLICATE_SCHEDULE_DATA_FAILURE = 'GET_DUPLICATE_SCHEDULE_DATA_FAILURE';

// Save Radiologist Shift Input Details
export const SAVE_RADIOLOGIST_SHIFT_INPUT_DETAILS_REQUEST = 'SAVE_RADIOLOGIST_SHIFT_INPUT_DETAILS_REQUEST';
export const SAVE_RADIOLOGIST_SHIFT_INPUT_DETAILS_SUCCESS = 'SAVE_RADIOLOGIST_SHIFT_INPUT_DETAILS_SUCCESS';
export const SAVE_RADIOLOGIST_SHIFT_INPUT_DETAILS_FAILURE = 'SAVE_RADIOLOGIST_SHIFT_INPUT_DETAILS_FAILURE';

// Delete Shift Input Details
export const DELETE_SHIFT_INPUT_DETAILS_REQUEST = 'DELETE_SHIFT_INPUT_DETAILS_REQUEST';
export const DELETE_SHIFT_INPUT_DETAILS_SUCCESS = 'DELETE_SHIFT_INPUT_DETAILS_SUCCESS';
export const DELETE_SHIFT_INPUT_DETAILS_FAILURE = 'DELETE_SHIFT_INPUT_DETAILS_FAILURE';

// Get Shift Input Details By ID
export const GET_SHIFT_INPUT_DETAILS_BY_ID_REQUEST = 'GET_SHIFT_INPUT_DETAILS_BY_ID_REQUEST';
export const GET_SHIFT_INPUT_DETAILS_BY_ID_SUCCESS = 'GET_SHIFT_INPUT_DETAILS_BY_ID_SUCCESS';
export const GET_SHIFT_INPUT_DETAILS_BY_ID_FAILURE = 'GET_SHIFT_INPUT_DETAILS_BY_ID_FAILURE';

// Get Simulator RPCE With Pagination
export const GET_SIMULATOR_RPCE_WITH_PAGINATION_REQUEST = 'GET_SIMULATOR_RPCE_WITH_PAGINATION_REQUEST';
export const GET_SIMULATOR_RPCE_WITH_PAGINATION_SUCCESS = 'GET_SIMULATOR_RPCE_WITH_PAGINATION_SUCCESS';
export const GET_SIMULATOR_RPCE_WITH_PAGINATION_FAILURE = 'GET_SIMULATOR_RPCE_WITH_PAGINATION_FAILURE';

// Get Capacity Table Grid Data With Pagination
export const GET_CAPACITY_TABLE_GRID_DATA_WITH_PAGINATION_REQUEST = 'GET_CAPACITY_TABLE_GRID_DATA_WITH_PAGINATION_REQUEST';
export const GET_CAPACITY_TABLE_GRID_DATA_WITH_PAGINATION_SUCCESS = 'GET_CAPACITY_TABLE_GRID_DATA_WITH_PAGINATION_SUCCESS';
export const GET_CAPACITY_TABLE_GRID_DATA_WITH_PAGINATION_FAILURE = 'GET_CAPACITY_TABLE_GRID_DATA_WITH_PAGINATION_FAILURE';

// Update Radiologist Shift Input Details
export const UPDATE_RADIOLOGIST_SHIFT_INPUT_DETAILS_REQUEST = 'UPDATE_RADIOLOGIST_SHIFT_INPUT_DETAILS_REQUEST';
export const UPDATE_RADIOLOGIST_SHIFT_INPUT_DETAILS_SUCCESS = 'UPDATE_RADIOLOGIST_SHIFT_INPUT_DETAILS_SUCCESS';
export const UPDATE_RADIOLOGIST_SHIFT_INPUT_DETAILS_FAILURE = 'UPDATE_RADIOLOGIST_SHIFT_INPUT_DETAILS_FAILURE';

// Update Capacity Table Reducer State
export const UPDATE_CAPACITY_TABLE_REDUCER = 'UPDATE_CAPACITY_TABLE_REDUCER';

// Draft Capacity Table Report
export const DRAFT_CAPACITY_TABLE_REPORT_REQUEST = 'DRAFT_CAPACITY_TABLE_REPORT_REQUEST';
export const DRAFT_CAPACITY_TABLE_REPORT_SUCCESS = 'DRAFT_CAPACITY_TABLE_REPORT_SUCCESS';
export const DRAFT_CAPACITY_TABLE_REPORT_FAILURE = 'DRAFT_CAPACITY_TABLE_REPORT_FAILURE';

// Shift Paste Input Duplicate Check
export const SHIFT_PASTE_INPUT_DUPLICATE_CHECK_REQUEST = 'SHIFT_PASTE_INPUT_DUPLICATE_CHECK_REQUEST';
export const SHIFT_PASTE_INPUT_DUPLICATE_CHECK_SUCCESS = 'SHIFT_PASTE_INPUT_DUPLICATE_CHECK_SUCCESS';
export const SHIFT_PASTE_INPUT_DUPLICATE_CHECK_FAILURE = 'SHIFT_PASTE_INPUT_DUPLICATE_CHECK_FAILURE';

// Get Capacity Table Refresh Data
export const GET_CAPACITY_TABLE_REFRESH_DATA_REQUEST = 'GET_CAPACITY_TABLE_REFRESH_DATA_REQUEST';
export const GET_CAPACITY_TABLE_REFRESH_DATA_SUCCESS = 'GET_CAPACITY_TABLE_REFRESH_DATA_SUCCESS';
export const GET_CAPACITY_TABLE_REFRESH_DATA_FAILURE = 'GET_CAPACITY_TABLE_REFRESH_DATA_FAILURE';

// Get Simulator Worklist With Pagination
export const GET_SIMULATOR_WORKLIST_WITH_PAGINATION_REQUEST = 'GET_SIMULATOR_WORKLIST_WITH_PAGINATION_REQUEST';
export const GET_SIMULATOR_WORKLIST_WITH_PAGINATION_SUCCESS = 'GET_SIMULATOR_WORKLIST_WITH_PAGINATION_SUCCESS';
export const GET_SIMULATOR_WORKLIST_WITH_PAGINATION_FAILURE = 'GET_SIMULATOR_WORKLIST_WITH_PAGINATION_FAILURE';

// Get Capacity RPCE Details
export const GET_CAPACITY_RPCE_DETAILS_REQUEST = 'GET_CAPACITY_RPCE_DETAILS_REQUEST';
export const GET_CAPACITY_RPCE_DETAILS_SUCCESS = 'GET_CAPACITY_RPCE_DETAILS_SUCCESS';
export const GET_CAPACITY_RPCE_DETAILS_FAILURE = 'GET_CAPACITY_RPCE_DETAILS_FAILURE';

// Get Capacity Details (for worklist)
export const GET_CAPACITY_DETAILS_REQUEST = 'GET_CAPACITY_DETAILS_REQUEST';
export const GET_CAPACITY_DETAILS_SUCCESS = 'GET_CAPACITY_DETAILS_SUCCESS';
export const GET_CAPACITY_DETAILS_FAILURE = 'GET_CAPACITY_DETAILS_FAILURE';

// Get All Emulator Data (for simulator refresh - worklist)
export const GET_ALL_EMULATOR_DATA_REQUEST = 'GET_ALL_EMULATOR_DATA_REQUEST';
export const GET_ALL_EMULATOR_DATA_SUCCESS = 'GET_ALL_EMULATOR_DATA_SUCCESS';
export const GET_ALL_EMULATOR_DATA_FAILURE = 'GET_ALL_EMULATOR_DATA_FAILURE';

// Get All Emulator RPCE Data (for simulator refresh - RPCE)
export const GET_ALL_EMULATOR_RPCE_DATA_REQUEST = 'GET_ALL_EMULATOR_RPCE_DATA_REQUEST';
export const GET_ALL_EMULATOR_RPCE_DATA_SUCCESS = 'GET_ALL_EMULATOR_RPCE_DATA_SUCCESS';
export const GET_ALL_EMULATOR_RPCE_DATA_FAILURE = 'GET_ALL_EMULATOR_RPCE_DATA_FAILURE';

// Get QGenda Tasks And Schedules
export const GET_QGENDA_TASKS_SCHEDULES_REQUEST = 'GET_QGENDA_TASKS_SCHEDULES_REQUEST';
export const GET_QGENDA_TASKS_SCHEDULES_SUCCESS = 'GET_QGENDA_TASKS_SCHEDULES_SUCCESS';
export const GET_QGENDA_TASKS_SCHEDULES_FAILURE = 'GET_QGENDA_TASKS_SCHEDULES_FAILURE';

// Delete Duplicate Shift Paste Input Data
export const DELETE_DUPLICATE_SHIFT_PASTE_INPUT_DATA_REQUEST = 'DELETE_DUPLICATE_SHIFT_PASTE_INPUT_DATA_REQUEST';
export const DELETE_DUPLICATE_SHIFT_PASTE_INPUT_DATA_SUCCESS = 'DELETE_DUPLICATE_SHIFT_PASTE_INPUT_DATA_SUCCESS';
export const DELETE_DUPLICATE_SHIFT_PASTE_INPUT_DATA_FAILURE = 'DELETE_DUPLICATE_SHIFT_PASTE_INPUT_DATA_FAILURE';


